// Generated by Melange

import * as Buhta_components__ToastView from "./ToastView.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(toast) {
  return function (onExpired) {
    return function (children) {
      return JsxRuntime.jsxs("div", {
                  children: [
                    children,
                    JsxRuntime.jsx("div", {
                          children: toast !== undefined ? JsxRuntime.jsx(Buhta_components__ToastView.make, {
                                  toast: toast,
                                  onExpired: onExpired
                                }) : null,
                          className: "absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2"
                        })
                  ],
                  className: "relative"
                });
    };
  };
}

function ToastContainer(Props) {
  return Curry._1(make(Props.toast)(Props.onExpired), Props.children);
}

const make$1 = ToastContainer;

export {
  make$1 as make,
}
/* Buhta_components__ToastView Not a pure module */
